import React, { useState } from "react";
import { IconButton, InputAdornment } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { colors } from "../../../theme/theme";

import {
  StyledWrapper,
  StyledLabelBox,
  StyledLabel,
  RequiredMark,
  StyledInputContainer,
  StyledTagInput,
  StyledValidationText,
  StyledChipsContainer,
  StyledChip,
} from "./CustomTagInput.styles";

const TAG_LABEL_MAX_LENGTH = 15;

const CustomTagInput = ({
  hashTags,
  setHashTags,
  width,
  label,
  color,
  placeholder,
  required = false,
  validation = false,
  validationMsg = "",
}) => {
  const [inputValue, setInputValue] = useState("");

  const safeTags = Array.isArray(hashTags) ? hashTags : [];

  const handleAddTag = () => {
    const trimmed = inputValue.trim();
    if (trimmed && !safeTags.includes(trimmed)) {
      setHashTags([...safeTags, trimmed]);
      setInputValue("");
    }
  };

  const handleDeleteTag = (tagToDelete) => {
    setHashTags(safeTags.filter((tag) => tag !== tagToDelete));
  };

  const formatTagLabel = (tag) =>
    tag.length > TAG_LABEL_MAX_LENGTH
      ? `${tag.slice(0, TAG_LABEL_MAX_LENGTH)}...`
      : tag;

  return (
    <StyledWrapper>
      {label && (
        <StyledLabelBox>
          <StyledLabel color={color}>
            {label}{" "}
            {required && <RequiredMark component="span">*</RequiredMark>}
          </StyledLabel>
        </StyledLabelBox>
      )}
      <StyledInputContainer color={color}>
        <StyledTagInput
          color={color}
          fullWidth
          placeholder={placeholder}
          value={inputValue ?? ""}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddTag()}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={handleAddTag}>
                  <AddIcon sx={{ color: color || colors.primary }} />
                </IconButton>
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            shrink: false,
          }}
        />
        {validation && (
          <StyledValidationText>
            {validationMsg || "Press Enter after filling each field."}
          </StyledValidationText>
        )}
        <StyledChipsContainer>
          {safeTags.map((tag, index) => (
            <StyledChip
              key={`${tag}-${index}`}
              label={formatTagLabel(tag)}
              onDelete={() => handleDeleteTag(tag)}
            />
          ))}
        </StyledChipsContainer>
      </StyledInputContainer>
    </StyledWrapper>
  );
};

export default CustomTagInput;
